<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'assignments_title' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'assignments_subTitle' | translate }}</div>
  <br />
  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav class="sidenav-panel" #sidenavassign mode="over" position="end" [fixedInViewport]="true"
        [fixedTopGap]="isMobile() ? 120 : 64" [disableClose]="true">
        <app-assign-cds-accesstoken *ngIf="assignment != null" 
          [assign]="assignment"
          (saved)="sidenavassign.close(); assignedClient($event)"
          (cancelled)="sidenavassign.close(); cancelledAssign($event)" 
          (loadingSpinner)="loadingSpinner($event)">
        </app-assign-cds-accesstoken>
      </mat-sidenav>
    </mat-sidenav-container>

    <div class="matTable-container mat-elevation-z8" *ngIf="media.isActive('lg') || media.isActive('xl') || media.isActive('md')">
      <mat-table matSort  #table [dataSource]="dataSource"
        class="mat-elevation-z8">

        <!-- Account Name Column -->
        <ng-container cdkColumnDef="account_name">
          <mat-header-cell fxFlex="15%" *cdkHeaderCellDef mat-sort-header>{{ 'account_name' | translate }}</mat-header-cell>
          <mat-cell fxFlex="15%" *cdkCellDef="let assign"> {{assign.account_name}} </mat-cell>
        </ng-container>

        <!-- Client ID Column -->
        <ng-container cdkColumnDef="client_id">
          <mat-header-cell fxFlex="40%" *cdkHeaderCellDef mat-sort-header>{{ 'client_id' | translate }}</mat-header-cell>
          <mat-cell fxFlex="40%" *cdkCellDef="let assign"> {{ 'secret_chars' | translate }} </mat-cell>
        </ng-container>

        <!-- Client Secret Column -->
        <ng-container cdkColumnDef="client_secret">
          <mat-header-cell fxFlex="40%" *cdkHeaderCellDef mat-sort-header>{{ 'client_secret' | translate }}</mat-header-cell>
          <mat-cell fxFlex="40%" *cdkCellDef="let assign"> {{ 'secret_chars' | translate }} </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="menu">
          <mat-header-cell fxFlex="5%" *cdkHeaderCellDef></mat-header-cell>
          <mat-cell fxFlex="5%" *cdkCellDef="let assign">

            <button mat-icon-button [matMenuTriggerData]="{ row: assign }" [matMenuTriggerFor]="menu" *ngIf="isContributor">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="assignCdsCC(assign)" matTooltip="Assign and modify Cds access token"
                matTooltipPosition="left">
                {{ 'edit' | translate }}
              </button>
            </mat-menu>

          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
    
    <br />

    <!-- Mobile view -->
    <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))" class="mobile-list">

      <mat-list-item *ngFor="let assign of dataSource.data">
        <div class="mobile-card">

          <div class="field">
            <span class="label">{{ 'account_name' | translate }}</span>
            <span class="value breakword">{{ assign.account_name }}</span>
          </div>

          <div class="field">
            <span class="label">{{ 'client_id' | translate }}</span>
            <span class="value breakword">{{ assign.client_id }}</span>
          </div>

          <div class="actions" *ngIf="isContributor">
            <button mat-stroked-button color="primary" (click)="assignCdsCC(assign)">
              {{ 'edit' | translate }}
            </button>
          </div>

        </div>
      </mat-list-item>

    </mat-list>

  </con-page-layout-content>
</con-page-layout>